import React, {   useState } from "react"
import { Link } from 'gatsby'
import { Modal, Button } from 'react-bootstrap'
import WhitepaperForm from "../components/whitepaper-form"


// const { useFormik } = React.lazy(() => import('formik'))
// const { object, string } = React.lazy(() => import('yup'))

const BroucherForm = props => {

  const form_name = "our company profile"
  const pdf_url = "https://www.digipay.guru/company-profile.pdf"
  const key = "company_profile_download_form"

  const [showScheduleCall, setShowScheduleCall] = useState(false);
  const handleShowScheduleCall = () => setShowScheduleCall(true);
  const handleCloseScheduleCall = () => setShowScheduleCall(false);
  return (
    <>
      <div className="icon-fix-footer">
        <Link
          to="#"
          onClick={(e) => {
            e.preventDefault();
            handleShowScheduleCall();
          }}
          className="btn btn-lg btn-primary-theme"
        >
          <span><i className="icon zmdi zmdi-hc-lg zmdi-download me-2"></i> Download Brochure</span>
        </Link>
      </div>
      
      <Modal size="lg" show={showScheduleCall} onHide={handleCloseScheduleCall} centered keyboard={false}>
        <Modal.Header className="flex-column border-0 pt-4 pt-lg-5 pb-0 text-center px-4 px-lg-5">
          <h3 className="modal-title mb-0">Please Fill The Form Below to Download Our Brochure
          </h3>
          <div className="text-end video-close-btn">
            <Button variant="" className="btn-close" onClick={handleCloseScheduleCall}></Button>
          </div>
        </Modal.Header>
        <Modal.Body className="p-4 p-lg-5">
          <WhitepaperForm
            form_name={form_name}
            pdf_url={pdf_url}
            form_key={key}
            personalized_consultation={true}
            discuss_detail={false}
          />
        </Modal.Body>
      </Modal>
    </>
  )
}

export default BroucherForm
